module.exports = __webpack_public_path__ + "assets/img/a91e570d491d01a1899d7e55e3cf6a15.webp";